import InfoTooltip from 'components/InfoTooltip';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';

interface TimeDataProps {
    label: string;
    children: React.ReactNode;
    tooltip?: string;
    tooltipValues?: ComponentProps<typeof FormattedMessage>['values'];
    /** Classes for the value. */
    className?: string;
    inline?: boolean;
}

const LabelledData = ({ label, children, tooltip, tooltipValues, className, inline }: TimeDataProps): JSX.Element => {
    const hasTooltip = tooltip !== undefined;

    if (inline) {
        return (
            <span>
                <span className="text-grey-600 mr-[0.5ch] text-[0.75rem]">
                    <FormattedMessage id={label} />
                </span>
                <span className={className}>{children}</span>
            </span>
        );
    }

    return (
        <div>
            <span className="text-caption text-fg-secondary mr-[0.5ch]">
                <FormattedMessage id={label} />
            </span>
            {hasTooltip ? (
                <span className={cn('text-caption inline-flex', className)}>
                    <span className="flex gap-1">
                        {children}
                        <InfoTooltip text={tooltip} values={tooltipValues} className="text-inherit" />
                    </span>
                </span>
            ) : (
                <span className={cn('text-caption', className)}>{children}</span>
            )}
        </div>
    );
};

export default LabelledData;
